import React, { Component } from 'react';
import { Button, FormGroup, ControlLabel, Grid, Row, Col, Table, Modal, Panel } from 'react-bootstrap';
import Select from "react-select";

import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { SortIndicator } from '../../../SortIndicator';
import { LinesCommand } from '../../commands/LinesCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';
import { OrderSetter } from '../helpers/OrderSetter';
import { LinesHelper } from './helpers/LinesHelper';
import { TmlScheduleSet } from './tabs/TmlScheduleSet';

export class TmlBusSchedForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dependencies: {
                lines: [],
                stops: []
            },
            form: {
                line: undefined,
                stops: [],
                scheduleSets: []
            },
            render: {
                addSetForm: false
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            commands: {
                lines: new LinesCommand(),
                stops: new PathStopsCommand()
            },
            actions: {
                isLoadingLines: false,
                isLoadingStops: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            transient: {
                selection: {
                    id: undefined,
                    type: 0,
                    dataCode: undefined,
                    stops: [],
                    scheduleSets: []
                }
            }
        };
    }

    componentDidMount() {
        const { edition } = this.props;

        if (undefined !== edition) {
            edition.addObserver(this);
        }
    }

    componentWillUnmount() {
        const { edition } = this.props;

        if (undefined !== edition) {
            edition.removeObserver(this);
        }
    }

    // ----------------------

    updateNetwork() {
        const { actions, form } = this.state;

        actions.isLoadingLines = true;
        form.line = undefined;

        this.setState({
            form: form,
            actions: actions
        }, () => {
            this.getLines(this.props.edition);
            this.onChangeLineSelected();
        });
    }

    // ----------------------

    getLines(edition) {
        if (0 === edition.network || "0" === edition.network || null === edition.network || undefined === edition.network) {
            this.listSuccessCallback([], "lines", "isLoadingLines", () => this.finalizeGetLinesCallback());
            return;
        }

        const { actions, commands } = this.state;

        commands.lines.list(
            edition.network,
            (a) => this.listSuccessCallback(a, "lines", "isLoadingLines", () => this.finalizeGetLinesCallback()),
            (a) => this.listErrorCallback(a, "lines", "isLoadingLines")
        );

        actions.isLoadingLines = true;

        this.setState({
            actions: actions
        });
    }

    getStops(edition) {
        const { form, actions, commands } = this.state;

        if (undefined === form.line) {
            return;
        }

        commands.stops.listStops(
            edition.network,
            form.line.id,
            (a) => this.listSuccessCallback(a, "stops", "isLoadingStops", () => this.finalizeGetStopsCallback()),
            (a) => this.listErrorCallback(a, "stops", "isLoadingStops")
        );

        actions.isLoadingStops = true;

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, action, callback = undefined) {
        const { dependencies, actions } = this.state;

        actions[action] = false;
        dependencies[dataType] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, action) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[dataType] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    finalizeGetLinesCallback() {
        const { parentDependencies } = this.props;
        const { dependencies, form } = this.state;
        const { selection } = parentDependencies;

        // Update filter with the lines
        if ("function" === typeof (this.props.onUpdateFilterConfigsDependencies)) {
            this.props.onUpdateFilterConfigsDependencies("lines", dependencies.lines.map(line => { return { id: line.id, code: line.code, name: line.goName } }));
        }

        if (undefined === selection || null === selection || 0 !== selection.layout) {
            // Nothing to be done
            return;
        }

        form.line = dependencies.lines.find(line => line.code === selection.dataCode);

        this.setState({
            form: form
        }, () => this.onChangeLineSelected());
    }

    finalizeGetStopsCallback() {
        const { parentDependencies } = this.props;
        const { dependencies, form, transient } = this.state;
        const { selection } = parentDependencies;

        if (undefined === selection || null === selection || undefined === form.line) {
            transient.selection.id = 0;

            this.setState({
                transient: transient
            }, () => this.onUpdateData());

            return;
        }

        const dataSelection = selection.selections.find(dataSelection => 0 === dataSelection.type && dataSelection.dataCode === form.line.code);
        if (undefined === dataSelection) {
            transient.selection.id = 0;

            this.setState({
                transient: transient
            }, () => this.onUpdateData());

            return;
        }

        // Get stops ids using the selection stop codes
        if (Array.isArray(dataSelection.stops)) {
            form.stops = dependencies.stops.filter(stop => dataSelection.stops.includes(stop.code)).map(stop => stop.id);
        }

        // Map Schedules Sets
        form.scheduleSets = dataSelection.scheduleSets
            .map(scheduleSet => {
                const setOfDayTypes = parentDependencies.setOfDayTypes.find(set => set.id === scheduleSet.setOfDayTypesId);
                if (undefined === setOfDayTypes) {
                    return null;
                }

                const filteredSchedules = scheduleSet.schedules
                    .filter(schedule => {
                        const scheduleObj = parentDependencies.schedules.find(parentSchedule => parentSchedule.name === schedule);
                        if (undefined === scheduleObj) {
                            return false;
                        }

                        return undefined !== form.line &&
                            null !== form.line &&
                            Array.isArray(scheduleObj.lines) &&
                            scheduleObj.lines.includes(form.line.id) &&
                            this.isValidSetOfDayTypes(scheduleObj.setOfDayTypes, setOfDayTypes)
                    });

                return {
                    id: scheduleSet.id,
                    selectionId: scheduleSet.id,
                    season: scheduleSet.season,
                    title: scheduleSet.title,
                    alternateText: scheduleSet.alternateText,
                    setOfDayTypes: setOfDayTypes,
                    schedules: filteredSchedules.slice()
                };
            })
            .filter(scheduleSet => null !== scheduleSet);

        // Update selection transient state
        transient.selection.id = dataSelection.id;

        this.setState({
            form: form,
            transient: transient
        }, () => this.onUpdateData());
    }

    // ----------------------

    onChangeSort(column) {
        const { sort } = this.state;

        if (sort.column === column) {
            sort.order = sort.order === "ascending" ? "descending" : "ascending";
        } else {
            sort.column = column;
            sort.order = "ascending";
        }

        this.setState({
            sort: sort
        });
    }

    onChangeValue(e, property) {
        const { form } = this.state;

        form[property] = e.target.value;

        this.setState({
            form: form,
        }, () => {
            this.onUpdateData();
        });
    }

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
            else {
                this.onUpdateData();
            }
        });
    }

    onSelectAllStops() {
        const { dependencies, form } = this.state;

        if (form.stops.length === dependencies.stops.length) {
            form.stops = [];
        }
        else {
            form.stops = dependencies.stops
                .map(stop => stop.id);
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onStopRowClick(stop) {
        const { form } = this.state;

        if (form.stops.includes(stop)) {
            form.stops = form.stops
                .filter(formStop => formStop !== stop);
        }
        else {
            form.stops.push(stop);
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onClickAddSet() {
        const { render } = this.state;

        render.addSetForm = true;

        this.setState({
            render: render
        });
    }

    onClickCancelAddSetForm() {
        const { render } = this.state;

        render.addSetForm = false;

        this.setState({
            render: render
        });
    }

    onSelectAllSchedules(scheduleSetId, schedules) {
        const { form } = this.state;

        const scheduleSet = form.scheduleSets.find(scheduleSet => scheduleSet.id === scheduleSetId);
        if (undefined === scheduleSet) {
            return;
        }

        if (scheduleSet.schedules.length >= schedules.length) {
            scheduleSet.schedules = [];
        }
        else {
            scheduleSet.schedules = schedules.map(schedule => schedule.name);
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onScheduleRowClick(scheduleSetId, schedule) {
        const { form } = this.state;

        const scheduleSet = form.scheduleSets.find(scheduleSet => scheduleSet.id === scheduleSetId);
        if (undefined === scheduleSet) {
            return;
        }

        if (scheduleSet.schedules.includes(schedule)) {
            scheduleSet.schedules = scheduleSet.schedules
                .filter(formSchedule => formSchedule !== schedule);
        }
        else {
            scheduleSet.schedules.push(schedule);
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onSaveScheduleSet(scheduleSet) {
        const { form } = this.state;

        if (0 === scheduleSet.id) {
            const { render } = this.state;

            form.scheduleSets.push({
                id: form.scheduleSets.reduce((previous, current) => previous > current.id ? previous : current.id, 0) + 1,
                setOfDayTypes: scheduleSet.setOfDayTypes,
                season: scheduleSet.season,
                title: scheduleSet.title,
                alternateText: scheduleSet.alternateText,
                schedules: []
            });

            render.addSetForm = false;
            this.setState({
                render: render
            });
        }
        else {
            const formScheduleSet = form.scheduleSets.find(formScheduleSet => formScheduleSet.id === scheduleSet.id);
            if (undefined === formScheduleSet) {
                return;
            }

            if (formScheduleSet.setOfDayTypes !== scheduleSet.setOfDayTypes) {
                formScheduleSet.setOfDayTypes = scheduleSet.setOfDayTypes;
                formScheduleSet.schedules = [];
            }
            formScheduleSet.season = scheduleSet.season;
            formScheduleSet.title = scheduleSet.title;
            formScheduleSet.alternateText = scheduleSet.alternateText;
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onRemoveScheduleSet(scheduleSetId) {
        const { form } = this.state;

        form.scheduleSets = form.scheduleSets.filter(scheduleSet => scheduleSet.id !== scheduleSetId);

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onSaveSchesuleSetsOrder(scheduleSets) {
        const { form } = this.state;

        form.scheduleSets = scheduleSets;

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
        this.onHideSchedulesSetsOrder();
    }

    onHideSchedulesSetsOrder() {
        this.props.onHideSchedulesSetsOrder();
    }

    onChangeLineSelected() {
        const { edition } = this.props;
        const { form, transient } = this.state;

        if (undefined !== form.line && null !== form.line) {
            this.props.getSelectionData(form.line.code, () => this.getStops(edition));
        }

        form.stops = [];
        form.scheduleSets = [];
        transient.selection.id = undefined;

        this.setState({
            form: form,
            transient: transient
        }, () => this.onUpdateData());
    }

    onUpdateData() {
        const { dependencies, form, transient } = this.state;

        let data = {};
        if (undefined !== form.line && null !== form.line) {
            data = {
                line: form.line.id,
                stops: form.stops,
                scheduleSets: form.scheduleSets.map(scheduleSet => {
                    return {
                        setOfDayTypesId: undefined === scheduleSet.setOfDayTypes || null === scheduleSet.setOfDayTypes ? 0 : scheduleSet.setOfDayTypes.id,
                        season: scheduleSet.season,
                        title: scheduleSet.title,
                        alternateText: scheduleSet.alternateText,
                        schedules: scheduleSet.schedules
                    };
                }),
            };

            transient.selection.dataCode = form.line.code;
            transient.selection.stops = dependencies.stops.filter(stop => form.stops.includes(stop.id)).map(stop => stop.code);
            transient.selection.scheduleSets = form.scheduleSets.map(scheduleSet => {
                return {
                    id: scheduleSet.selectionId,
                    setOfDayTypesId: undefined === scheduleSet.setOfDayTypes || null === scheduleSet.setOfDayTypes ? 0 : scheduleSet.setOfDayTypes.id,
                    season: scheduleSet.season,
                    title: scheduleSet.title,
                    alternateText: scheduleSet.alternateText,
                    schedules: scheduleSet.schedules.slice()
                };
            });
        }
        else {
            transient.selection.dataCode = undefined;
            transient.selection.stops = [];
            transient.selection.scheduleSets = [];
        }

        this.props.onUpdateData(data);
        this.props.onUpdateSelection(transient.selection);
    }

    onTabSelected(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------------

    sort(first, second) {
        const { sort } = this.state;

        var a = (first)[sort.column];
        var b = (second)[sort.column];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sort.order === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sort.order === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sort.order === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    isValidSetOfDayTypes(scheduleSetOfDayTypes, setSetOfDayTypes) {
        return scheduleSetOfDayTypes.dayTypes.some(scheduleDayType =>
            undefined !== setSetOfDayTypes.dayTypes.find(setDayType => scheduleDayType.id === setDayType.id)
        );
    }

    // ----------------------

    renderAlertIcon(isGenerated) {
        if (isGenerated) {
            return null;
        }

        return (
            <div className="icon-img icon-alert warning"></div>
        );
    }

    renderTooManyStopsWarning(isLoadingStops, line) {
        if (isLoadingStops) {
            return null;
        }

        const output = [];
        if (33 < line.nrGoStops) {
            output.push(
                <div key="go-path-stops-warning" className="icon-img icon-alert warning"><span className="bussched-stops-warning">Linha com {line.nrGoStops} paragens no sentido de Ida!</span></div>
            );
        }

        if (33 < line.nrReturnStops) {
            output.push(
                <div key="return-path-stops-warning" className="icon-img icon-alert warning"><span className="bussched-stops-warning">Linha com {line.nrReturnStops} paragens no sentido de Volta!</span></div>
            );
        }

        if (37 < line.nrCircularStops) {
            output.push(
                <div key="circular-path-stops-warning" className="icon-img icon-alert warning"><span className="bussched-stops-warning">Linha Circular com {line.nrCircularStops} paragens!</span></div>
            );
        }

        if (0 === output.length) {
            return null;
        }

        return (
            <div className="padding-bottom-10">
                {output}
            </div>
        );
    }

    renderForm() {
        const { dependencies, form } = this.state;

        const lines = dependencies.lines
            .sort((a, b) => a.code - b.code);

        return (
            <FormGroup controlId="formLine">
                <Row>
                    <Col sm={3} md={2}>
                        <ControlLabel className="padding-top-10">Linha</ControlLabel>
                    </Col>
                    <Col sm={9} md={10}>
                        <Select
                            className="custom-multiselect"
                            placeholder="Sem Linha selecionada"
                            noOptionsMessage={() => "Sem Linhas Configuradas"}
                            onChange={(e) => this.onSelectValue(e, "line", () => { this.onChangeLineSelected(); })}
                            options={lines}
                            isMulti={false}
                            isClearable={true}
                            isOptionSelected={function (a) {
                                return form.line === a;
                            }}
                            getOptionValue={value => value}
                            getOptionLabel={label => (
                                <div className="custom-multiselect-label">
                                    {this.renderAlertIcon(label.isGenerated)}
                                    <span>{label.code} | {label.goName}</span>
                                </div>
                            )}
                            filterOption={(candidate, input) => {
                                if (undefined === input || null === input || "" === input) {
                                    return true;
                                }

                                const inputInvariantCase = input.toLowerCase();
                                const codeInvariantCase = candidate.data.code.toLowerCase();
                                const goNameInvariantCase = candidate.data.goName.toLowerCase();

                                if (codeInvariantCase.includes(inputInvariantCase) || goNameInvariantCase.includes(inputInvariantCase)) {
                                    return true;
                                }

                                return `${codeInvariantCase} | ${goNameInvariantCase}`.includes(inputInvariantCase);
                            }}
                            value={form.line} />
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    renderStopsTab(stopsList, selectedStops) {
        const { sort } = this.state;

        if (0 === stopsList.length) {
            return (
                <Panel className="margin-top-50">
                    <Panel.Body>Sem paragens associadas à linha.</Panel.Body>
                </Panel>
            );
        }

        return (
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th className="width-20p" onClick={() => this.onChangeSort('code')}>
                            Código {sort.column === "code" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                        </th>
                        <th className="width-60p" onClick={() => this.onChangeSort('name')}>
                            Nome {sort.column === "name" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                        </th>
                        <th className="width-20p">
                            Orientação
                        </th>
                        <th>
                            <Button bsSize="small" className="pull-right" onClick={() => this.onSelectAllStops()}>SELECIONAR TUDO</Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        stopsList.sort((a, b) => this.sort(a, b)).map((stop, idx) =>
                            <tr key={`stop-${idx}`}
                                className={`busched selectable ${selectedStops.includes(stop.id) ? "checked" : ""}`}
                                onClick={() => this.onStopRowClick(stop.id)}>
                                <td>{stop.code !== 'undefined' ? stop.code : ''}</td>
                                <td>{stop.name !== 'undefined' ? stop.name : ''}</td>
                                <td colSpan={2}>{LinesHelper.getOrientationLabel(stop.orientation)}</td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        );
    }

    renderSetSeason(season, isFirstSeason) {
        return (
            <div key={`season-${season.replace(" ", "-")}`} className="tml-stop-sched-schedule-set-season-info">
                {isFirstSeason ? null : <hr />}
                <span>{season}</span>
            </div>
        );
    }

    renderScheduleSetTabContent(edition, scheduleSets) {
        const { parentDependencies } = this.props;
        const { form } = this.state;

        const output = [];
        let isFirstSeason = true;
        for (var key in scheduleSets) {
            output.push(this.renderSetSeason(key, isFirstSeason))

            scheduleSets[key].forEach(scheduleSet => {
                const schedules = parentDependencies.schedules
                    .filter(schedule =>
                        undefined !== form.line &&
                        null !== form.line &&
                        Array.isArray(schedule.lines) &&
                        schedule.lines.includes(form.line.id) &&
                        this.isValidSetOfDayTypes(schedule.setOfDayTypes, scheduleSet.setOfDayTypes)
                    );

                output.push(
                    <TmlScheduleSet value={scheduleSet}
                        className="padding-0"
                        key={`schedule-set-${scheduleSet.season}-${scheduleSet.title}-${output.length}`}
                        edition={edition}
                        setOfDayTypes={parentDependencies.setOfDayTypes}
                        schedules={schedules}
                        onScheduleRowClick={(a, b) => this.onScheduleRowClick(a, b)}
                        onSelectAllSchedules={(a, b) => this.onSelectAllSchedules(a, b)}
                        onRemove={(a) => this.onRemoveScheduleSet(a)}
                        onSave={(a) => this.onSaveScheduleSet(a)} />
                );
            });

            isFirstSeason = false;
        }

        if (0 === output.length) {
            return (
                <Panel className="margin-top-50">
                    <Panel.Body>Sem horários associados à linha.</Panel.Body>
                </Panel>
            );
        }

        return output;
    }

    renderScheduleSetTab(edition, scheduleSets) {
        const schedules = {};
        scheduleSets.forEach(schedule => {
            if (schedule.season in schedules) {
                schedules[schedule.season].push(schedule);
            } else {
                schedules[schedule.season] = [schedule];
            }
        });

        return (
            <React.Fragment>
                {this.renderAddSetButton()}
                {this.renderAddSetForm()}
                {this.renderScheduleSetTabContent(edition, schedules)}
            </React.Fragment>
        );
    }

    renderAddSetButton() {
        return (
            <Button className="pull-right" onClick={() => this.onClickAddSet()}>ADICIONAR</Button>
        );
    }

    renderAddSetForm() {
        const { render } = this.state;

        if (!render.addSetForm) {
            return null;
        }

        return this.renderAddTab();
    }

    renderAddTab() {
        const { parentDependencies } = this.props;

        return (
            <Modal show={true} size="lg">
                <Modal.Header>
                    <Modal.Title>Adicionar Linha de Horário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TmlScheduleSet isEditing={true}
                        setOfDayTypes={parentDependencies.setOfDayTypes}
                        onSave={(a) => this.onSaveScheduleSet(a)}
                        onCancel={() => this.onClickCancelAddSetForm()} />
                </Modal.Body>
            </Modal>
        );
    }

    renderBody() {
        const { form } = this.state;

        if (undefined === form.line || null === form.line) {
            return null;
        }

        const { isLoadingSelectionData, isLoadingStops, isLoadingSchedules } = this.props;

        if (isLoadingSelectionData || isLoadingStops || isLoadingSchedules) {
            return (
                <LoadingSpinner />
            );
        }

        const { edition } = this.props;
        const { dependencies, actions } = this.state;

        return (
            <div>
                {this.renderTooManyStopsWarning(actions.isLoadingStops, form.line)}

                <Grid fluid>
                    <Row>
                        <Col><hr /></Col>
                    </Row>
                    <Row>
                        <Col md={6} sm={12}>{this.renderStopsTab(dependencies.stops, form.stops)}</Col>
                        <Col md={6} sm={12}>{this.renderScheduleSetTab(edition, form.scheduleSets)}</Col>
                    </Row>
                </Grid>
            </div>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return (
            <div>
                {this.renderForm()}
                {this.renderBody()}
            </div>
        );
    }

    renderOrderSetter(isSettingOrder) {
        const { form } = this.state;

        if (!isSettingOrder || 2 > form.scheduleSets.length) {
            return null;
        }

        return (
            <OrderSetter data={form.scheduleSets}
                title="Conjunto de Horários"
                header="Descrição"
                getValueCallback={(a) => `[${a.season}] ${a.title} ## ${a.setOfDayTypes.name}`}
                onSave={(a) => this.onSaveSchesuleSetsOrder(a)}
                onHide={() => this.onHideSchedulesSetsOrder()} />
        );
    }

    render() {
        const { isVisible } = this.props;

        if (!isVisible) {
            return null;
        }

        const { isLoadingSetOfDayTypes, isSettingOrder } = this.props;
        const { actions, message } = this.state;

        return (
            <div>
                {this.renderContent(actions.isLoadingLines || isLoadingSetOfDayTypes)}
                {this.renderOrderSetter(isSettingOrder)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/tml/TmlBusSchedForm.js